<div class="app" [attr.data-role]="role">
  <aside class="sidebar" [class.collapsed]="collapsed">
    <!-- SESSION-webplanner-002 / GAP-WEBPLANNER-002: proto §3.2 sidebar-head —
         brand stack (logo + workspace-tag) on the left, .sidebar-toggle chevron
         on the right. Replaced the prior bespoke .role-chip block with the
         canonical .workspace-tag organism (single-line uppercase pill with
         persona dot, no nested name; the full name lives in .sidebar-foot). -->
    <div class="sidebar-head">
      <div class="sidebar-brand">
        <!-- GAP-MEETUX-ADMINUI-004A / SESSION-meet-ux-016: dark-shell logo
             variant (white wordmark) on the dark-navy sidebar. -->
        <a class="logo-mark" href="/">
          <img src="assets/images/logo/awvent-logo-dark.png" alt="awvent" class="logo-img">
        </a>
        <span class="workspace-tag" *ngIf="roleConfig">
          <span class="dot" [class]="'dot-' + personaTint"></span>{{ roleConfig.label }}
        </span>
      </div>
      <button type="button"
              class="sidebar-toggle"
              (click)="toggleCollapse()"
              [attr.aria-label]="collapsed ? 'Expand sidebar' : 'Collapse sidebar'"
              [title]="collapsed ? 'Expand sidebar' : 'Collapse sidebar'">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 6l-6 6 6 6"/></svg>
      </button>
    </div>

    <div class="sidebar-sect-label">Workspace</div>
    <nav class="sidebar-nav">
      <ng-container *ngFor="let item of navItems">
        <!-- SESSION-webplanner-002: parent w/ children renders as a nav-group:
             [parent link + chevron] above, indented .nav-children below.
             A parent w/o children renders the existing single .nav-item. -->
        <div *ngIf="hasChildren(item); else flatItem"
             class="nav-group"
             [class.collapsed]="isGroupCollapsed(item.id)"
             [attr.data-group]="item.id">
          <div class="nav-item-row">
            <a [routerLink]="item.route"
               class="nav-item"
               [class.active]="isNavActive(item.id)"
               [ngClass]="isNavActive(item.id) ? 'active-' + personaTint : ''"
               [attr.data-label]="item.label">
              <ng-container *ngTemplateOutlet="navIcon; context: { $implicit: item.icon }"></ng-container>
              <span>{{ item.label }}</span>
              <span *ngIf="item.badge" class="nav-item-badge">{{ item.badge }}</span>
            </a>
            <button type="button"
                    class="nav-toggle"
                    (click)="toggleGroup(item.id)"
                    [attr.aria-label]="'Toggle ' + item.label">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>
            </button>
          </div>
          <div class="nav-children">
            <a *ngFor="let child of item.children"
               [routerLink]="child.route"
               class="nav-item nav-item-sub"
               [class.active]="isNavActive(child.id)"
               [ngClass]="isNavActive(child.id) ? 'active-' + personaTint : ''"
               [attr.data-label]="child.label">
              <ng-container *ngTemplateOutlet="navIcon; context: { $implicit: child.icon }"></ng-container>
              <span>{{ child.label }}</span>
              <span *ngIf="child.badge" class="nav-item-badge">{{ child.badge }}</span>
            </a>
          </div>
        </div>
        <ng-template #flatItem>
          <a [routerLink]="item.route"
             class="nav-item"
             [class.active]="isNavActive(item.id)"
             [ngClass]="isNavActive(item.id) ? 'active-' + personaTint : ''"
             [attr.data-label]="item.label">
            <ng-container *ngTemplateOutlet="navIcon; context: { $implicit: item.icon }"></ng-container>
            <span>{{ item.label }}</span>
            <span *ngIf="item.badge" class="nav-item-badge">{{ item.badge }}</span>
          </a>
        </ng-template>
      </ng-container>
    </nav>

    <div class="sidebar-sect-label">Library</div>
    <nav class="sidebar-nav">
      <a *ngFor="let item of libraryItems"
         [routerLink]="item.route"
         class="nav-item"
         [class.active]="isNavActive(item.id)"
         [ngClass]="isNavActive(item.id) ? 'active-' + personaTint : ''"
         [attr.data-label]="item.label">
        <ng-container *ngTemplateOutlet="navIcon; context: { $implicit: item.icon }"></ng-container>
        <span>{{ item.label }}</span>
      </a>
    </nav>

    <div class="sidebar-spacer"></div>

    <!-- Bottom persona block: a link to /user-settings (SPEC-web-planner-034 AC-4; the SPEC-027 account menu is removed,
         Sign out lives on the settings page). Keeps the proto's persona row (initials avatar in the persona tint,
         "{roleLabel} · {workspaceLabel}" subtitle, chevron). No email line, no theme button (PD-3). -->
    <div class="sidebar-foot">
      <!-- SPEC-web-planner-024 AC-3: the "How Awvent works" link and its /help page are removed (the page was a placeholder). -->
      <a class="sidebar-user" routerLink="/user-settings" aria-label="Open user settings">
        <div class="avatar avatar-sm" [ngClass]="'avatar-' + personaTint">{{ userInitials }}</div>
        <!-- SESSION-webplanner-002: .sidebar-user-meta class is the proto's
             collapse-target — hidden in the collapsed rail via organisms.css. -->
        <div class="sidebar-user-meta" style="flex: 1; min-width: 0;">
          <div class="sidebar-user-name">{{ userDisplayName }}</div>
          <div class="sidebar-user-role">{{ roleLabel }}<ng-container *ngIf="workspaceLabel"> · {{ workspaceLabel }}</ng-container></div>
        </div>
        <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="var(--navy-300)" stroke-width="1.5" aria-hidden="true"><path d="M6 4l4 4-4 4"/></svg>
      </a>
    </div>
  </aside>

  <div class="app-main">
    <ng-content></ng-content>
  </div>
</div>

<!-- Inline SVGs lifted verbatim from Webplanner _Remix/assets/js/app-shell.js:62-78.
     DO NOT extract to per-icon files — keeping them inline (PD-1: [ngSwitch], no
     sanitizer) lets the proto's `currentColor` / `var(--accent)` stroke colors
     resolve in the live DOM tree. One template, instantiated per nav item via
     *ngTemplateOutlet, so there is a single source of icon truth (no drift). -->
<ng-template #navIcon let-name>
  <ng-container [ngSwitch]="name">
    <svg *ngSwitchCase="'queue'"     width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M3 12h18M3 18h18"/></svg>
    <svg *ngSwitchCase="'users'"     width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>
    <svg *ngSwitchCase="'calendar'"  width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
    <svg *ngSwitchCase="'play'"      width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M23 7l-7 5 7 5V7zM14 5H3a2 2 0 00-2 2v10a2 2 0 002 2h11a2 2 0 002-2V7a2 2 0 00-2-2z"/></svg>
    <!-- SESSION-webplanner-002 / proto §3.2 (app-shell.js :: ICONS.sessions):
         layered-triangle (think "stacked sessions") — distinct from the
         video-player `play` glyph the IS sidebar was using before. -->
    <svg *ngSwitchCase="'sessions'"  width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><path d="M12 3l9 4.5-9 4.5-9-4.5L12 3z"/><path d="M3 12l9 4.5 9-4.5"/><path d="M3 16.5L12 21l9-4.5"/></svg>
    <!-- SESSION-webplanner-002 / proto §3.2 (app-shell.js :: ICONS.plus):
         plain "+" used by the "New session" sub-item under My Sessions. -->
    <svg *ngSwitchCase="'plus'"      width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>
    <svg *ngSwitchCase="'box'"       width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/></svg>
    <svg *ngSwitchCase="'briefcase'" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16"/></svg>
    <svg *ngSwitchCase="'building'"  width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="4" y="3" width="16" height="18" rx="1.5"/><line x1="9" y1="7" x2="9" y2="7.01"/><line x1="15" y1="7" x2="15" y2="7.01"/><line x1="9" y1="11" x2="9" y2="11.01"/><line x1="15" y1="11" x2="15" y2="11.01"/><line x1="9" y1="15" x2="9" y2="15.01"/><line x1="15" y1="15" x2="15" y2="15.01"/></svg>
    <svg *ngSwitchCase="'pie'"       width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21.21 15.89A10 10 0 118 2.83"/><path d="M22 12A10 10 0 0012 2v10z"/></svg>
    <svg *ngSwitchCase="'trending'"  width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>
    <!-- SESSION-meet-ux-017 (Phase 2 visual-fidelity pass): proto `activity`
         icon — heartbeat/EKG line, distinct from `trending` (price arrow). -->
    <svg *ngSwitchCase="'activity'"  width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12h4l2.5 7 5-14L17 12h4"/></svg>
    <!-- SESSION-meet-ux-017 (Phase 2 visual-fidelity pass): proto `help` icon. -->
    <svg *ngSwitchCase="'help'"      width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
    <svg *ngSwitchCase="'megaphone'" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 11l18-5v12L3 14v-3z"/><path d="M11.6 16.8a3 3 0 11-5.8-1.6"/></svg>
    <svg *ngSwitchCase="'home'"      width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 12l9-9 9 9M5 10v10h4v-6h6v6h4V10"/></svg>
    <svg *ngSwitchCase="'shield'"    width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
    <svg *ngSwitchCase="'card'"      width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="6" width="20" height="13" rx="2"/><path d="M2 10h20"/></svg>
    <svg *ngSwitchCase="'database'"  width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><ellipse cx="12" cy="5" rx="9" ry="3"/><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/></svg>
    <svg *ngSwitchCase="'settings'"  width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-2 2 2 2 0 01-2-2v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 01-2-2 2 2 0 012-2h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 010-2.83 2 2 0 012.83 0l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 012-2 2 2 0 012 2v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 0 2 2 0 010 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 012 2 2 2 0 01-2 2h-.09a1.65 1.65 0 00-1.51 1z"/></svg>
  </ng-container>
</ng-template>
